import React from 'react'
import { Container, Card } from '@scentregroup/ui'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Markdown from '../markdown'
import Article from '../article'
import Status from '../status'
import ResponsiveImage from '../responsive-image'
import PotentialLink from '../potential-link'
import analyticsUtils from '../../helpers/analytics-utils'
import { STATUS_NOT_FOUND } from '../../constants'
import style from './index.module.scss'

import errorMessages from './static-content.js'

const ErrorFeature = ({ error, status }) => {
  const INDENT = 2
  const content = errorMessages[status] || errorMessages['default']

  const devMessage = `
  \`\`\`
  ${JSON.stringify(error, null, INDENT)}
  \`\`\`
  `
  // Tracks 404 events for analytics
  if (status && status === STATUS_NOT_FOUND) {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.NOT_FOUND_404,
    })
  }

  return (
    <Status status={status}>
      <div className={style.ErrorFeature}>
        <PotentialLink link={content.link}>
          <ResponsiveImage
            lazyLoad={false}
            angleOrigin={'top-right'}
            desktopImageUrl={content.imageUrl}
            mobileImageUrl={content.imageUrl}
            mobileRatio="standard"
            desktopRatio="feature"
            numberOfItems={1}
            alt={content.title}
          />
        </PotentialLink>
        <Container centred type="large" className={classNames(style.Container)}>
          <Card className={style.Card}>
            <Article link={content.link} heading={content.title}>
              <Markdown content={content.body} />
              {typeof __DEV__ !== 'undefined' && __DEV__ && error && (
                <Markdown content={devMessage} />
              )}
            </Article>
          </Card>
        </Container>
      </div>
    </Status>
  )
}

ErrorFeature.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  status: PropTypes.number.isRequired,
}

export default ErrorFeature
